import { Promise } from '../polyfills';
import { globalState } from './patch-utils';
import { SCHEDULE, INVOKE, FETCH } from '../constants';
import { scheduleMicroTask } from '../utils';
import { isFetchSupported } from '../http/fetch';
export function patchFetch(callback) {
  if (!isFetchSupported()) {
    return;
  }
  function scheduleTask(task) {
    task.state = SCHEDULE;
    callback(SCHEDULE, task);
  }
  function invokeTask(task) {
    task.state = INVOKE;
    callback(INVOKE, task);
  }
  function handleResponseError(task, error) {
    task.data.aborted = isAbortError(error);
    task.data.error = error;
    invokeTask(task);
  }
  function readStream(stream, task) {
    var reader = stream.getReader();
    var _read = function read() {
      reader.read().then(function (_ref) {
        var done = _ref.done;
        if (done) {
          invokeTask(task);
        } else {
          _read();
        }
      }, function (error) {
        handleResponseError(task, error);
      });
    };
    _read();
  }
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var fetchSelf = this;
    var args = arguments;
    var request, url;
    var isURL = input instanceof URL;
    if (typeof input === 'string' || isURL) {
      request = new Request(input, init);
      if (isURL) {
        url = request.url;
      } else {
        url = input;
      }
    } else if (input) {
      request = new Request(input, init);
      url = request.url;
    } else {
      return nativeFetch.apply(fetchSelf, args);
    }
    var task = {
      source: FETCH,
      state: '',
      type: 'macroTask',
      data: {
        target: request,
        method: request.method,
        url: url,
        aborted: false
      }
    };
    return new Promise(function (resolve, reject) {
      globalState.fetchInProgress = true;
      scheduleTask(task);
      var promise;
      try {
        promise = nativeFetch.apply(fetchSelf, [request]);
      } catch (error) {
        reject(error);
        task.data.error = error;
        invokeTask(task);
        globalState.fetchInProgress = false;
        return;
      }
      promise.then(function (response) {
        var clonedResponse = response.clone ? response.clone() : {};
        resolve(response);
        scheduleMicroTask(function () {
          task.data.response = response;
          var body = clonedResponse.body;
          if (body) {
            readStream(body, task);
          } else {
            invokeTask(task);
          }
        });
      }, function (error) {
        reject(error);
        scheduleMicroTask(function () {
          handleResponseError(task, error);
        });
      });
      globalState.fetchInProgress = false;
    });
  };
}
function isAbortError(error) {
  return error && error.name === 'AbortError';
}